import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import { orderHasBookingProtection } from './orderInsuranceUtils'
import { getMaxOccupancies, getOccupanciesFromReservations } from 'lib/offer/occupancyUtils'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'

export function getExtraGuestCapacity(offer: App.HotelOffer, item: App.OrderItem, packageKey: string): {
  adults: number
  children: number
  infants: number
} | null {
  if (!offer) return null
  if (!item?.reservation) return null

  const pkg = offer.packages.find(p => p.uniqueKey === packageKey)

  const occupancy = getOccupanciesFromReservations(item.reservation)

  return getMaxOccupancies(pkg?.roomRate.capacities, occupancy, {
    maxChildAge: offer.property?.maxChildAge,
    maxInfantAge: offer.property?.maxInfantAge,
  })
}

interface canAddExtraGuestsOptions {
  ignoreAvailableRates?: boolean
}

export function canAddExtraGuests(offer: App.HotelOffer, order: App.Order, item: App.OrderItem, availableRates: Array<App.OfferAvailableRate>, options: canAddExtraGuestsOptions = {}): boolean {
  if (!offer) return false
  if (!item) return false
  if (!item.reservation) return false

  if (!isFlashHotelOffer(offer)) {
    return false
  }

  const hasBookingProtection = orderHasBookingProtection(order)
  if (hasBookingProtection) return false

  const hasTransfers = order.transferItems.filter(transfer => transfer.status === 'completed').length > 0
  if (hasTransfers) return false

  const itemPackage = item.package as App.OrderItemHotelPackage
  const key = getPackageUniqueKey(itemPackage.id, itemPackage.duration, itemPackage.roomRateId)

  const maxCapacities = getExtraGuestCapacity(offer, item, key)
  if (!maxCapacities) return false

  const currentRateAvailability = availableRates?.find(rate => rate.packageUniqueKey === key)

  if (!options.ignoreAvailableRates && !currentRateAvailability) return false

  return maxCapacities.adults > item.reservation.adults ||
    maxCapacities.children > (item.reservation.children ?? 0) ||
    maxCapacities.infants > (item.reservation.infants ?? 0)
}
